export const LEAD_ADD_FOLIO = "LEAD_ADD_FOLIO";

export const SYSTEM_USER = "SYSTEM_USER";

export const EMAIL = "EMAIL";

export const USER_PORTAL = "USER_PORTAL";

export const SESSION_ID = "SESSION_ID";

export const SUBSCRIPTION = "SUBSCRIPTION_KEY";

export const TOKEN_ID = "TOKEN_ID";
